
import React, { useCallback, useEffect, useMemo, useState } from "react";
import InformadosTable from "./InformadosTable";
import { Form, Formik } from 'formik';
import Button from '../../../Components/Button/Button';
import validations from '../../../Utils/Validations/Validations';
import SelectCheckField from "../../../Components/SelectCheckField/SelectCheckField";
import RangeDatePicker from "../../../Components/RangeDatePicker/RangeDatePicker";
import moment from 'moment';
import { COLUMNS } from "../Utils/ColumnsInformados";
import { ObtenerArchivosInformados } from "../Services/ObtenerArchivosInformados";
import { EnumAreaNegocio, EnumTablaPaginacion } from "../../../Utils/Enumeradores/ComunEnum";
import useLogin from "../../Autenticacion/Hooks/useLogin";
import { ObtenerIndicador } from "../Services/ObtenerIndicador";

const InformesInformada = () => {
	const [data, setData] = useState([]);
	const columns = useMemo(() => COLUMNS, []);
	const { usuario } = useLogin();
	const [pageCount, setPageCount] = useState(0);
	const [indicadorSeleccionado, setIndicadorSeleccionado] = useState(-1);
	const [exigenciaSeleccionada, setExigenciaSeleccionada] = useState(-1);
	const [exigencias, setExigencias] = useState([]);
	const [indicadores, setIndicadores] = useState([]);
	const [indicadoresExigencia, setIndicadoresExigencia] = useState([]);
	const [fechaSleccionada, setFechaSleccionada] = useState([moment().subtract(1, 'M').toDate(), new Date()]);
	const [initialValues, setInitialValues] = useState({
		indicador: indicadorSeleccionado,
		exigencia: exigenciaSeleccionada,
		periodo: fechaSleccionada
	});
	const [{ pageIndex, pageSize, sortBy }, setPagination] =
		useState({
			pageIndex: 0,
			pageSize: EnumTablaPaginacion.CantidadPaginacion,
			sortBy: []
		});

	const [valoresFormularioEnvio, setValoresFormularioEnvio] = useState({
		paginacion: {
			numeroPagina: pageIndex
			, cantidadRegistros: pageSize
			, orderByAscending: false
			, ordenadoPor: "fechaInformado"
		},
		datosBusqueda: {
			idUsuario: usuario.id
			, indicadorId: indicadorSeleccionado
			, exigenciaId: exigenciaSeleccionada
			, fechaInicio: moment().subtract(1, 'M').format()
			, fechaFin: moment().format()
		}
	});

	useEffect(() => {
		const usuarioId = {
			idUsuario: usuario.id,
			areaNegocioId: EnumAreaNegocio.Conservacion
		};
	
		async function fetchIndicadores() {
			try {
				const response = await ObtenerIndicador(usuarioId);
				if (response && response.status === 200 && response.data) {
					setIndicadoresExigencia(response.data);
				}
			} catch (error) {
				console.error("Error obteniendo indicadores:", error);
			}
		}
	
		fetchIndicadores();
	}, [usuario.id, ]);

		const postObtenerArchivosInformados = async (values) => {
			const resp = await ObtenerArchivosInformados(values);
			if (resp) {
				if (resp.status === 200) {
					setPageCount(resp.data.cantidadPaginas);
					setData(resp.data.listadoInformes);
				} else if (resp.status === 206) {
					setPageCount(0);
					setData([]);
				}
			}
		};


		const fetchData = useCallback(({ formulario, pageIndex, sortBy = []}) => {
			formulario.paginacion.numeroPagina = pageIndex + 1;
			formulario.paginacion.ordenadoPor = sortBy.length > 0 ? sortBy[0].id : formulario.paginacion.ordenadoPor;
			formulario.paginacion.orderByAscending = sortBy.length > 0 ? !sortBy[0].desc : formulario.paginacion.orderByAscending;
			postObtenerArchivosInformados(formulario);
		}, []);


		function BuscarArchivosInformados(values) {
			let formEnvio = valoresFormularioEnvio;
			formEnvio.paginacion.numeroPagina = 0;
			formEnvio.paginacion.orderByAscending = false;
			formEnvio.paginacion.ordenadoPor = "FechaInforme";
	
			formEnvio.datosBusqueda.idUsuario = usuario.id;
			formEnvio.datosBusqueda.indicadorId = values.indicador;
			formEnvio.datosBusqueda.exigenciaId = values.exigencia;
			formEnvio.datosBusqueda.fechaInicio = values.periodo[0];
			formEnvio.datosBusqueda.fechaFin = values.periodo[1];

			setValoresFormularioEnvio(formEnvio);
			fetchData({ formulario: formEnvio, pageIndex: 0, sortBy: [] });
			setPagination({
				pageIndex: formEnvio.paginacion.numeroPagina,
				pageSize: formEnvio.paginacion.cantidadRegistros,
				sortBy: []
			});
		};


		const filtroExigencia = () => {
			let listaExigencias = indicadoresExigencia;
			if(indicadorSeleccionado !== -1){
				listaExigencias = indicadoresExigencia
				.filter(item => item.indicadorId == indicadorSeleccionado)[0].exigencias
				.map(item => ({
					value: item.id,
					label: `${item.sigla} - ${item.descripcion}`
				}))
			}
			else{
				listaExigencias = indicadoresExigencia
				.flatMap(item => item.exigencias.map(ex => ({
					value: ex.id,
					label: `${item.sigla} - ${ex.sigla} - ${ex.descripcion}`
				})))
			}
	
			listaExigencias = [{ value: -1, label: 'Todos' }, ...listaExigencias];
			setExigencias(listaExigencias)
		}
	
		const filtroIndicador = () => {
			const listaIndicadores = [
				{ value: -1, label: 'Todos' },
				...indicadoresExigencia.map(item => ({
					value: item.indicadorId,
					label: item.sigla
				}))
			];
		
			setIndicadores(listaIndicadores);
		};
	  

		useEffect(() => {
			setInitialValues((prev) => ({
				...prev,
				indicador: indicadorSeleccionado,
				exigencia: exigenciaSeleccionada
			}));
			if(indicadoresExigencia.length>0){
				filtroIndicador();
				filtroExigencia();
			}
		}, [indicadorSeleccionado, exigenciaSeleccionada, indicadoresExigencia]);
	
		useEffect(() => {
			setInitialValues((prev) => ({
				...prev,
				periodo: fechaSleccionada
			}));
		}, [fechaSleccionada]);

		useEffect(() => {
			if (valoresFormularioEnvio.datosBusqueda.indicadorId >= -1) {
				fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
				setPagination(values => ({
					...values,
					sortBy: sortBy
				}));
			}
		}, [usuario, valoresFormularioEnvio]);

	return (
		<div>
			<div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-5 gap-3">
				<Formik
				enableReinitialize
				initialValues={initialValues}
				validate={validations}
				onSubmit={(values) => {
					BuscarArchivosInformados(values);
				}}
				>
					{({ values, setFieldValue, setFieldTouched, }) => (
						<Form className="form mb-0">
							<div className="tools order-1 order-lg-0 align-items-start">
								<SelectCheckField
									name="indicador"
									label='Indicadores'
									options={indicadores}
									value={values.indicador} 
									onChange={(selected, values) => {
										setFieldValue(values);
										setIndicadorSeleccionado(values);
										setExigenciaSeleccionada(-1);
										}}
									onBlur={setFieldTouched}
									isMulti={false}
								/>
								<SelectCheckField
									name="exigencia"
									label='Exigencias'
									options={exigencias}
									value={values.exigencia}
									onChange={(selected, values) => {
										setFieldValue(values);
										setExigenciaSeleccionada(values);
										}}
									onBlur={setFieldTouched}
									isMulti={false}
								/>
								<RangeDatePicker
									startMaxDate={new Date()}
									startMinDate={null}
									endMaxDate={new Date()}
									endMinDate={null}
									name="periodo"
									onChange={(selected, values) => {
										setFieldValue(values);
										setFechaSleccionada(values);
									}}
									onBlur={setFieldTouched}
								/>
								<Button type="submit" design="btn-primary">Buscar</Button>
							</div>
						</Form>
					)}
				</Formik>
			</div>
            <InformadosTable
				columns={columns}
				data={data}
				fetchData={fetchData}
				pageCount={pageCount}
				currentpage={pageIndex}
				pageSize={pageSize}
				sortBy={sortBy}
				setPagination={setPagination}
				valoresFormularioEnvio={valoresFormularioEnvio}
				setValoresFormularioEnvio={setValoresFormularioEnvio}
			/>

		</div>
	)
}
export default InformesInformada;
